(function($) {


	var wow = new WOW(
      {
  		mobile: false
    }
    )
    wow.init();

	//universal vars
	var 	siteHeader = $('header.site-header'),
			backgroundwrapper = $('.background-wrapper'),
			scrollDistance = $(window).scrollTop();

	$(document).ready(function(){

		$('.testimonials-slider').slick({
		  dots: true,
		  infinite: true,
		  speed: 300,
		  slidesToShow: 1,
		  arrows: true,
		});

		$('.homepage-slider').slick({
		  dots: true,
		  infinite: false,
		  speed: 1000,
		  slidesToShow: 1,
		  arrows: true,
		  adaptiveHeight: false,
		  autoplay: true,
		});

		var lightbox = new SimpleLightbox('.image-gallery>.single-image>a', { /* options */ });

			$('.image-gallery').slick({
			  arrows: false,
			  infinite: false,
			  speed: 300,
			  slidesToShow: 1,
			  asNavFor: '.slider-nav'
			});

			$('.slider-nav').slick({
			  slidesToShow: 3,
			  slidesToScroll: 1,
			  infinite: false,
			  asNavFor: '.image-gallery',
			  dots: false,
			  centerMode: true,
			  focusOnSelect: true
			});
		
	});

	$(window).on('load',function() {
	  	parallaxSetup(backgroundwrapper);
	  	parallaxScroll(scrollDistance,backgroundwrapper);
	  	//adjust page content padding
		//pageContentPadding();
		sizeBoxes('.post-wrapper .entry-excerpt');
		sizeBoxes('a.woocommerce-LoopProduct-link.woocommerce-loop-product__link');
		sizeBoxes('.product-cat-title.main-boxes h2');
		sizeBoxes('.section-header-top.home-header ');
		sizeBoxes('.app-wrapper .entry-excerpt');
		
		
		// sizeBoxes('.article-details h2');
		// sizeBoxes('.entry-excerpt');

		// Animate loader off screen
	    $("#loader").fadeOut(300);
	});

	var resizeTimer;

	$(window).on('resize', function(e) {

	  clearTimeout(resizeTimer);
	  resizeTimer = setTimeout(function() {

	  parallaxSetup(backgroundwrapper);
	  parallaxScroll(scrollDistance,backgroundwrapper);
	            
	  }, 250);
	});
	
	//scroll numbers setting
	var a = 0;

	$(window).on('scroll',function() {
		scrollDistance = $(window).scrollTop();

		//pageContentPadding();
		parallaxScroll(scrollDistance,backgroundwrapper);
		stickyHeaderClass(scrollDistance,400,siteHeader);

	  
	});

	//parallax setup
	var parallaxSetup = function(parallaxSelector) {
	if($(window).width() > 767) {
	var backgroundWrapper = $(parallaxSelector); // find all the parallax backgrounds

	$(backgroundWrapper).each(function(index){
			var backgroundWrapperTop = $(this).offset(), //element's distance from the top
				backgroundWrapperHeight = $(this).innerHeight(); //element's height

			$(this).data('top-distance', backgroundWrapperTop.top);
			$(this).data('element-height', backgroundWrapperHeight);
			});
	}
		};

	//parallax animation
	var parallaxScroll = function(scrollDistanceMonitor,$backgroundWrapper){
		//parallax bg
		if($(window).width() > 767) {
		$($backgroundWrapper).each(function(index){
			var backgroundWrapperImage = $(this).children('img'), //the image within the element
			    topDistance = $(this).data('top-distance'),
			    elementHeight = $(this).data('element-height'),
			    bottomOfElement = topDistance - elementHeight,
			    scrollSet = 0 - 50 + ((scrollDistanceMonitor - bottomOfElement) / 100);

			if(scrollDistanceMonitor >= (bottomOfElement)) {
				backgroundWrapperImage.css('transform', 'translate(-50%,' + scrollSet + '%)');
			}

		})
		}
	};

	//sticky header function
	var stickyHeaderClass = function(scrollDistanceMonitor, classDistance, headerSelector){
		if(scrollDistanceMonitor > classDistance) {
			$(headerSelector).addClass('scrolled');
			$('.top-title').fadeOut(300, function(){
				$('.scroll-title').fadeIn(300, function() {
					$('.site-title').addClass('scaled-title');
					$('ul#extra-nav').removeClass('small-margin-bottom').addClass('no-margin-bottom');

				});
			});	
		}
		else {
			$(headerSelector).removeClass('scrolled');
			$('.scroll-title').fadeOut(0, function(){
				$('.top-title').fadeIn(300, function() {
					$('.site-title').removeClass('scaled-title');
					$('ul#extra-nav').addClass('small-margin-bottom').removeClass('no-margin-bottom');
				});
			});
		}
	};

	var sizeBoxes = function(boxSelector){
		var boxSize = 0;

		$(boxSelector).each(function(index){
			var heightSet = $(this).innerHeight();
			if(heightSet > boxSize) {
				boxSize = heightSet;
			}
		});
		if($(window).width() > 767) {
			$(boxSelector).css('height', boxSize + 'px');
		}
		console.log(boxSize);
	};


//open and close search menu
$('button.search-toggle').on("click", function (event) {
    event.preventDefault();
    $('body').toggleClass('search-open');
    event.stopPropagation();
});


$(document).on('click' , function(e){
    var $menu = $('.nav-primary'),
        $targetBody = $('body'),
        $menuButton = $('.menu-toggle'),
        $searchOverlayForm = $('.search-overlay-form'),
        $searchOverlay = $(".search-overlay"),
        $menuSearchButton = $('.menu-search a');

    // When the search menu is open this will close it on click outside form
    if (!$searchOverlayForm.is(e.target) // if the target of the click isn't the container...
    && $searchOverlayForm.has(e.target).length === 0 && !$menuSearchButton.is(e.target) && $targetBody.hasClass('search-open')) 
    // ... nor a descendant of the container

    {       event.preventDefault();
            $($targetBody).removeClass('search-open');
            event.stopPropagation();
    }
});

$(document).bind('keydown', function(e) {
	//alert(e.which);
    if (e.which == 27) {
        $('body').removeClass('search-open');
    }
}); 

//open and close search menu
$('.mini-cart-toggle').on("click", function (event) {
    event.preventDefault();
    $('.mini-cart').toggleClass('opened');
    $('body').toggleClass('cart-opened');
    event.stopPropagation();
});

$(document).on('click' , function(e){
    var $menu = $('.nav-primary'),
        $targetBody = $('body'),
        $menuButton = $('.menu-toggle'),
        $miniCart = $('.mini-cart')
        // $searchOverlay = $(".search-overlay"),
        // $menuSearchButton = $('.menu-search a');

    // When the search menu is open this will close it on click outside form
    if (!$miniCart.is(e.target) // if the target of the click isn't the container...
    && $miniCart.has(e.target).length === 0 && !$miniCart.is(e.target) && $targetBody.hasClass('cart-opened')) 
    // ... nor a descendant of the container

    {       event.preventDefault();
            $($targetBody).removeClass('cart-opened');
            $('.mini-cart').toggleClass('opened');
            event.stopPropagation();
    }
});

jQuery(document).ready(function($){
    $('body').on( 'added_to_cart', function(){
        event.preventDefault();
	    $('.mini-cart').toggleClass('opened');
	    $('body').toggleClass('cart-opened');
	    event.stopPropagation();
    });
});

	//animate all anchor links

	document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});
	
})( jQuery );
